'use strict';

/* Скрипты */
import setSwiper from './modules/sliders.js';
import { drive_trainersInfo } from './site.js';
import { drive_top } from './site.js';
import { drive_faq } from './site.js';
import { drive_counter } from './site.js';
import { logicForm } from './site.js';
import { drive_venobox } from './site.js';
import { drive_audioPlayer } from './site.js';
import { driveScrollTo } from './site.js';
import { banner } from './site.js';
import { seeAll } from './site.js';
import { modalGoAway } from './site.js';
import { tabooCopy } from './site.js';
import { drive_rotate } from './site.js';

document.addEventListener('DOMContentLoaded', () => {
  drive_trainersInfo();
  drive_top();
  drive_faq();
  drive_counter('#counter', '.timer');
  drive_counter('.infoBlock', '.infoGraficBlock__number');
  if (location.href.split('/')[3] == 'izmenenie-ubejdeniy-onlayn-trenajer') {
    logicForm(); 
  }
  drive_venobox();
  drive_audioPlayer();
  driveScrollTo();
  modalGoAway();
  tabooCopy();
  banner();
  seeAll('.infoBlock__button', '.infoBlock__hidden', 70, 205);
  seeAll('.semanticBlock__button', '.semanticBlock__hidden', 70, 205);
  seeAll('.letter-block__button', '.letter-block__hide', 70, 205);
  seeAll('.about__button', '.about__hidden', 70, 205);
  setSwiper('.blog-post', 'blog', 'blog');
  setSwiper('.ph_video_swiper', 'blog', 'video');
  setSwiper('.says__slide', 'testi', 'testi');
  setSwiper('.cases__left', 'cases', 'cases');
  setSwiper('.news', 'news', 'news');
  setSwiper('.publication__swiper', 'publication', 'publication');
  drive_rotate();

  if (window.innerWidth <= 768) {
    setSwiper('.prices__swiper', 'prices', 'prices');
  }
});
